import { createSignal } from '@react-rxjs/utils';
import { bind } from '@react-rxjs/core';

export const [setReserveDialog$, setReserveDialog] = createSignal<boolean>();

export const [useReserveDialog, dialog$] = bind(setReserveDialog$, false);
